function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
/**
 * 获取客户端IP，此IP无法伪造
 * PS.此IP为直连服务器的IP，亦即，如果用户经过代理机，则获取到的为代理机的IP
 *
 * @param req
 */ export var getUserRemoteIP = function(req) {
    var remoteIP = req.headers['x-ttcdn-real-ip'] // kairong:门神提出来，使用CLB接入的域名他们只能通过x-ttcdn-real-ip进行打击
     || req.headers['x-ecdn-real-ip'] // 接入ecdn后，这里才是用户真实IP
     || req.headers['x-real-ip']; // 未接入ecdn时的用户ip获取方式；或者运维配置将ecdn的ip写到了这里
    if (!remoteIP) {
        var ipList = (req.headers['x-forwarded-for'] || '').replace(/\s/g, '').split(',');
        var ref;
        ref = _slicedToArray(ipList, 1), remoteIP = ref[0], ref; // 链路中的第一个ip。
    }
    remoteIP = remoteIP || req.connection.remoteAddress || req.ip;
    return remoteIP || '127.0.0.1';
};
